module.exports = __webpack_public_path__ + "static/styles-9b23ef6abb6cb927843b6a53e05f4e55.jpg";